function deferred( ) {
  let resolve, reject
  const promise = new Promise( ( res, rej ) => {
    resolve = res
    reject = rej
  } )
  promise.resolve = resolve
  promise.reject = reject
  return promise
}

export default {
  deferred
}
